var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-swiper',{ref:"commonSwiper",staticClass:"swiper",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.imgList),function({ configer },index){return _c('my-swipe-item',{key:index,on:{"click":function($event){return _vm.tapSwiper(configer)}}},[_c('img',{attrs:{"src":configer.img}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }